// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import demandCollectionActionTypes from './demand-collection.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	// GET DEMAND LOAN LIST
	getDemandMemberLoanInfoResponse: null,
	getDemandMemberLoanInfoArr: [],
	// UPDATE DEMAND COLLECTION REVERT
	updatedDemandCollectionRevertResponse: null,
	// UPDATE THRIFT PAID
	updatedThriftPaidResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** *********************  START MEMBER LOAN LIST DETAILS  ******************** */
		case demandCollectionActionTypes.GET_DEMAND_LOAN_LIST_SUCCESS:
			return {
				...state,
				getDemandMemberLoanInfoResponse: action.payload,
				getDemandMemberLoanInfoArr: docodeHexResponse(
					action.payload,
					'FetchDemandForTodayCollectionKey',
				),
			};

		case demandCollectionActionTypes.GET_DEMAND_LOAN_LIST_FAILURE:
			return { ...state, getDemandMemberLoanInfoResponse: action.payload };

		case demandCollectionActionTypes.GET_DEMAND_LOAN_LIST_RESPONSE_CHANGED:
			return { ...state, getDemandMemberLoanInfoResponse: null };
		/** *********************  END MEMBER LOAN LIST DETAILS  ******************** */

		/** *********************  START UPDATE DEMAND COLLECTION  ******************** */
		case demandCollectionActionTypes.UPDATE_DEMAND_COLLECTION_REVERT_SUCCESS:
			return {
				...state,
				updatedDemandCollectionRevertResponse: action.payload,
			};

		case demandCollectionActionTypes.UPDATE_DEMAND_COLLECTION_REVERT_FAILURE:
			return { ...state, updatedDemandCollectionRevertResponse: action.payload };

		case demandCollectionActionTypes.UPDATE_DEMAND_COLLECTION_REVERT_RESPONSE_CHANGED:
			return { ...state, updatedDemandCollectionRevertResponse: null };

		/** *********************  END UPDATE DEMAND COLLECTION  ******************** */

		/** *********************  START UPDATE THRIFT PAID  ******************** */
		case demandCollectionActionTypes.UPDATE_THRIFT_PAID_SUCCESS:
			return {
				...state,
				updatedThriftPaidResponse: action.payload,
			};

		case demandCollectionActionTypes.UPDATE_THRIFT_PAID_FAILURE:
			return { ...state, updatedThriftPaidResponse: action.payload };

		case demandCollectionActionTypes.UPDATE_THRIFT_PAID_RESPONSE_CHANGED:
			return { ...state, updatedThriftPaidResponse: null };

		/** *********************  END UPDATE THRIFT PAID  ******************** */
		default:
			return state;
	}
};
